import type { DiffResult, ItemForOrder } from './types';

export const calculateOrderItemDiffs = <T extends ItemForOrder>(
	initialItems: T[],
	newItems: T[]
): DiffResult<T> => {
	const initialItemLookup = createItemLookup(initialItems);
	const newItemLookup = createItemLookup(newItems);

	const added: T[] = [];
	const removed: T[] = [];
	const changed: Array<{ before: T; after: T; }> = [];

	for (const [key, itemInInitialArray] of Object.entries(initialItemLookup)) {
		const itemInNewArray = newItemLookup[key];

		if (!itemInNewArray) {
			removed.push(itemInInitialArray);
			continue;
		}

		if (itemInInitialArray.quantity !== itemInNewArray.quantity) {
			changed.push({ before: itemInInitialArray, after: itemInNewArray });
		}
	}

	for (const [key, itemInNewArray] of Object.entries(newItemLookup)) {
		const itemInInitialArray = initialItemLookup[key];

		if (!itemInInitialArray) {
			added.push(itemInNewArray);
		}
	}

	return { added, removed, changed };
};

const createItemLookup = <T extends ItemForOrder>(items: T[]): Record<string, T> => {
	const lookup = {};
	for (const it of items) {
		lookup[itemLookupKey(it)] = it;
	}
	return lookup;
};

const itemLookupKey = <T extends ItemForOrder>(item: T) => {
	if (!item.itemDepartmentId) {
		throw new Error('Using items without department');
	}
	return `${item.itemId}_${item.itemDepartmentId}`;
};
